import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import AssociateForm from "../components/AssociateForm";

const ForAssociates = () => {
  return (
    <>
      <TopBanner content={"For Associates"} />
      <ContentWrapper>
        <h2>
          Grow With Wealthies Become a <span>Verified Associate</span>
        </h2>
        <VideoWrapper>
          <video width="640" height="360" loop autoPlay muted playsInline>
            <source src="/assets/forAssociates.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </VideoWrapper>
        <p>
          At Wealthies.in, we support professionals and businesses by providing
          high-quality, interest-based financial leads. Every lead you receive
          is genuine, verified, and ready for meaningful engagement saving your
          time and effort.
        </p>
        <h2>How It Works</h2>
        <ol>
          <li>
            Customer Inquiry - Individuals reach out to us via our website,
            campaigns, or financial education platforms to learn about various
            financial topics and solutions.
          </li>
          <li>
            Initial Conversation - Our trained team speaks to them, understands
            their interest, and shares relevant educational insights.
          </li>
          <li>
            Lead Verification - We manually verify each lead’s intent and
            details before sharing with our registered associates.
          </li>
          <li>
            You Take Over - You connect directly with a verified customer,
            ensuring better engagement and conversion.
          </li>
        </ol>
        <h2>Why Choose Wealthies?</h2>
        <ul>
          <li>100% Verified & Qualified Leads</li>
          <li>No random data only genuine, interest-driven inquiries</li>
          <li>Easy onboarding and fast lead access</li>
          <li>Dedicated support for associates</li>
          <li>Clear lead replacement policy</li>
        </ul>
        <h2>Let’s Grow Together</h2>
        <p>
          Whether you’re just starting or scaling up, Wealthies.in is built to
          support your growth.
        </p>
        <p>
          Reach us at
          <a href="mailto:sales@wealthies.in">
            <b> sales@wealthies.in </b>
          </a>
          or fill the form below to get started:
        </p>
        c
        <AssociateForm />
      </ContentWrapper>
    </>
  );
};

export default ForAssociates;

export const VideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35%;
  flex-direction: column;

  video {
    mix-blend-mode: multiply;
  }
  @media (max-width: 900px) {
    width: 100%;
    padding: 10px;
    video {
      width: 100%;
      height: auto;
    }
  }
`;
const ContentWrapper = styled.div`
  padding: 80px;
  h2 {
    color: #005f73;
    /* font-size: 32px; */
    margin-bottom: 20px;
  }
  a {
    color: #005f73;
    text-decoration: underline;
  }

  span {
    color: #fdc500;
  }

  p,
  ul,
  ol {
    font-size: 1.1rem;
    line-height: 1.6;
    color: #333;
    margin-bottom: 20px;
  }
  @media (max-width: 900px) {
    padding: 20px;
    text-align: left;

    p,
    ul,
    ol {
      font-size: 1.1rem;
    }
  }
`;
